<template>
  <div class="time-assess">
    <ComBox>
      <template #title>
        <TitleBar title="火点时效考核">
          <template #icon>
            <img
              src="@/assets/dataScreen/icon-assess.png"
              style="width: 35px; height: 33px; margin-right: 1px"
            />
          </template>
          <template #right>
            <TabBar :list="tabList" v-model="currentTab" @change="changeTab"/>
          </template>
        </TitleBar>
      </template>
      <div class="chart-list">
        <div class="chart-item">
          <div class="chart-title">超时次数</div>
          <div class="chart-wrapper">
            <ChartBar :chart-data="countData" />
          </div>
        </div>
        <div class="chart-item">
          <div class="chart-title">平均处理时长(分钟)</div>
          <div class="chart-wrapper">
            <ChartBar :chart-data="durationData" />
          </div>
        </div>
      </div>
    </ComBox>
  </div>
</template>

<script>
  import TitleBar from "../../common/TitleBar.vue";
  import ComBox from "../../common/ComBox.vue";
  import TabBar from "../../common/TabBar.vue";
  import ChartBar from "./components/ChartBar/index.vue";
  import icon from "@/assets/dataScreen/icon-assess.png";
  import { getFireTimelinessAssessment } from "../../../../../api/dataScreen";
  import { changeDateTab } from "../../../../../utils/time";

  export default {
    name: "TimeAssess",
    components: { TitleBar, ComBox, TabBar, ChartBar },
    data() {
      return {
        icon,
        currentTab: "1",
        searchForm: {
          startTime: '',
          endTime: ''
        },
        tabList: [
          { label: "昨日", value: "1" },
          { label: "本月", value: "2" },
          { label: "本年", value: "3" },
        ],
        countData: {
          name: "超标次数",
          xAxisData: ["北史家务镇", "东沽港镇", "落垡镇", "码头镇", "杨税务镇", "葛渔城镇", "调河头镇", "龙河高新区", "仇庄镇"],
          seriesData: [0, 0, 0, 0, 0, 0, 0, 0, 0],
        },
        durationData: {
          name: "平均处理时长",
          xAxisData: ["北史家务镇", "东沽港镇", "落垡镇", "码头镇", "杨税务镇", "葛渔城镇", "调河头镇", "龙河高新区", "仇庄镇"],
          seriesData: [0, 0, 0, 0, 0, 0, 0, 0, 0],
        },
      };
    },
    created() {},
    mounted() {
      this.changeTab('1')
    },
    methods: {
      changeTab (val) {
        this.searchForm.startTime = changeDateTab(val)[0]
        this.searchForm.endTime = changeDateTab(val)[1]
        this.getList()
      },
      getList () {
        getFireTimelinessAssessment(this.searchForm).then(res => {
          const countData= {
            name: "超标次数",
            xAxisData: ["北史家务镇", "东沽港镇", "落垡镇", "码头镇", "杨税务镇", "葛渔城镇", "调河头镇", "龙河高新区", "仇庄镇"],
            seriesData: [this.filterTimeNum('001', res.data).overtimeCount, this.filterTimeNum('008', res.data).overtimeCount,
              this.filterTimeNum('004', res.data).overtimeCount, this.filterTimeNum('006', res.data).overtimeCount,
              this.filterTimeNum('003', res.data).overtimeCount, this.filterTimeNum('007', res.data).overtimeCount,
              this.filterTimeNum('009', res.data).overtimeCount, this.filterTimeNum('002', res.data).overtimeCount,
              this.filterTimeNum('005', res.data).overtimeCount]
          }
          const durationData= {
            name: "平均处理时长",
            xAxisData: ["北史家务镇", "东沽港镇", "落垡镇", "码头镇", "杨税务镇", "葛渔城镇", "调河头镇", "龙河高新区", "仇庄镇"],
            seriesData:  [this.filterTimeNum('001', res.data).averageProcessTime, this.filterTimeNum('008', res.data).averageProcessTime,
              this.filterTimeNum('004', res.data).averageProcessTime, this.filterTimeNum('006', res.data).averageProcessTime,
              this.filterTimeNum('003', res.data).averageProcessTime, this.filterTimeNum('007', res.data).averageProcessTime,
              this.filterTimeNum('009', res.data).averageProcessTime, this.filterTimeNum('002', res.data).averageProcessTime,
              this.filterTimeNum('005', res.data).averageProcessTime]
          }
          this.countData = countData
          this.durationData = durationData
        })
      },
      filterTimeNum (code, data) {
        const list = data.filter(x => {
          return x.town === code
        })
        return list[0] ? list[0] : {}
      }
    },
  };
</script>

<style scoped lang="less">
  .time-assess {
    width: 100%;
    height: auto;
    flex: 6;

    .chart-list {
      box-sizing: border-box;
      width: 100%;
      height: 100%;
      padding-top: 15px;

      .chart-item {
        width: 100%;
        height: 50%;
        overflow: hidden;

        .chart-title {
          position: relative;
          height: 20px;
          padding-left: 14px;
          line-height: 20px;

          &::before {
            content: "";
            position: absolute;
            width: 4px;
            height: 20px;
            left: 0;
            top: 0;
            background-color: #1890ff;
          }
        }

        .chart-wrapper {
          width: 100%;
          height: calc(100% - 20px);
        }
      }
    }
  }
</style>
